import { render, staticRenderFns } from "./Model19.vue?vue&type=template&id=9ff0e2a4&scoped=true&"
import script from "./Model19.vue?vue&type=script&lang=js&"
export * from "./Model19.vue?vue&type=script&lang=js&"
import style0 from "./Model19.vue?vue&type=style&index=0&id=9ff0e2a4&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9ff0e2a4",
  null
  
)

export default component.exports